(() => {
  const drawer = document.querySelector('[data-ox-cart-drawer]');
  if (!drawer || drawer.dataset.oxCartReady === 'true') return;
  drawer.dataset.oxCartReady = 'true';

  const lines = drawer.querySelector('[data-ox-cart-lines]');
  const empty = drawer.querySelector('[data-ox-cart-empty]');
  const footer = drawer.querySelector('[data-ox-cart-footer]');
  const subtotal = drawer.querySelector('[data-ox-cart-subtotal]');
  const status = drawer.querySelector('[data-ox-cart-status]');
  const error = drawer.querySelector('[data-ox-cart-error]');
  const closeButton = drawer.querySelector('.ox-cart__panel [data-ox-cart-close]');
  const routeRoot = window.Shopify?.routes?.root || '/';
  const route = (path) => `${routeRoot}${path}`.replace(/([^:]\/)\/+/g, '$1');
  let lastTrigger = null;
  let busy = false;

  const money = (cents, currency) => new Intl.NumberFormat(
    document.documentElement.lang || 'fr-FR',
    { style: 'currency', currency: currency || 'EUR' }
  ).format((Number(cents) || 0) / 100);

  const setError = (message = '') => {
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const setStatus = (message = '') => {
    if (status) status.textContent = message;
  };

  const updateCounts = (count) => {
    document.querySelectorAll('[data-ox-cart-count]').forEach((node) => {
      node.textContent = `(${count})`;
      node.setAttribute('aria-label', `${count} article${count === 1 ? '' : 's'}`);
    });
  };

  const control = (label, action, item, quantity) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.oxCartChange = action;
    button.dataset.key = item.key;
    button.dataset.quantity = String(quantity);
    button.setAttribute('aria-label', label);
    button.textContent = action === 'decrement' ? '−' : action === 'increment' ? '+' : 'Retirer';
    if (action === 'remove') button.className = 'ox-cart__remove';
    return button;
  };

  const render = (cart) => {
    lines.replaceChildren();
    updateCounts(cart.item_count || 0);
    const hasItems = Array.isArray(cart.items) && cart.items.length > 0;
    empty.hidden = hasItems;
    footer.hidden = !hasItems;
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);

    (cart.items || []).forEach((item) => {
      const article = document.createElement('article');
      article.className = 'ox-cart__line';

      if (item.image) {
        const link = document.createElement('a');
        link.href = item.url;
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 90;
        image.height = 110;
        link.append(image);
        article.append(link);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'ox-cart__image-placeholder';
        article.append(placeholder);
      }

      const copy = document.createElement('div');
      copy.className = 'ox-cart__line-copy';
      const title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      copy.append(title);

      if (item.variant_title && item.variant_title !== 'Default' && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'ox-cart__variant';
        variant.textContent = item.variant_title;
        copy.append(variant);
      }

      const price = document.createElement('p');
      price.className = 'ox-cart__line-price';
      price.textContent = money(item.final_line_price, cart.currency);
      copy.append(price);

      const actions = document.createElement('div');
      actions.className = 'ox-cart__line-actions';
      const stepper = document.createElement('div');
      stepper.className = 'ox-cart__stepper';
      stepper.append(
        control(`Réduire la quantité de ${item.product_title}`, 'decrement', item, Math.max(0, item.quantity - 1)),
        Object.assign(document.createElement('span'), { textContent: String(item.quantity) }),
        control(`Augmenter la quantité de ${item.product_title}`, 'increment', item, item.quantity + 1)
      );
      actions.append(stepper, control(`Retirer ${item.product_title}`, 'remove', item, 0));
      copy.append(actions);
      article.append(copy);
      lines.append(article);
    });
  };

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, { headers: { Accept: 'application/json', ...(options.headers || {}) }, ...options });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'La mise à jour du panier a échoué.');
    return data;
  };

  const loadCart = async () => {
    const cart = await requestJson(route('cart.js'));
    render(cart);
    return cart;
  };

  const open = (trigger) => {
    lastTrigger = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ox-cart-open');
    document.dispatchEvent(new CustomEvent('ox:cart-toggle', { detail: { open: true } }));
    closeButton?.focus();
  };

  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ox-cart-open');
    document.dispatchEvent(new CustomEvent('ox:cart-toggle', { detail: { open: false } }));
    lastTrigger?.focus?.();
  };

  const change = async (key, quantity) => {
    if (busy) return;
    busy = true;
    setError();
    setStatus('Mise à jour du panier…');
    try {
      const cart = await requestJson(route('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      render(cart);
      setStatus(quantity === 0 ? 'Pièce retirée.' : 'Quantité mise à jour.');
    } catch (requestError) {
      setError(requestError.message);
      setStatus();
    } finally {
      busy = false;
    }
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-ox-cart-open]');
    if (opener) {
      event.preventDefault();
      setError();
      setStatus('Ouverture du panier…');
      try {
        await loadCart();
        setStatus();
        open(opener);
      } catch (requestError) {
        window.location.assign(opener.href);
      }
      return;
    }

    if (event.target.closest('[data-ox-cart-close]')) {
      close();
      return;
    }

    const changer = event.target.closest('[data-ox-cart-change]');
    if (changer) await change(changer.dataset.key, Number(changer.dataset.quantity));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  document.querySelectorAll('[data-ox-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy) return;
      busy = true;
      const submit = form.querySelector('[type="submit"]');
      const productError = form.querySelector('[data-ox-product-error]');
      submit?.setAttribute('aria-busy', 'true');
      if (productError) { productError.hidden = true; productError.textContent = ''; }
      try {
        await requestJson(route('cart/add.js'), { method: 'POST', body: new FormData(form) });
        await loadCart();
        setStatus('Pièce ajoutée au panier.');
        open(submit);
      } catch (requestError) {
        if (productError) {
          productError.textContent = requestError.message;
          productError.hidden = false;
        }
      } finally {
        submit?.removeAttribute('aria-busy');
        busy = false;
      }
    });
  });
})();
